// extracted by mini-css-extract-plugin
module.exports = {"address":"_716d4aa6"};